import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["chip", "input"];

  select(event) {
    this.setGroup(event.currentTarget.dataset.group);
  }

  setGroup(group) {
    this.inputTargets.forEach((input) => { input.value = group; });

    this.chipTargets.forEach((chip) => {
      const active = chip.dataset.group === group;
      chip.classList.toggle("bg-amber-500", active);
      chip.classList.toggle("border-amber-500", active);
      chip.classList.toggle("text-neutral-950", active);
      chip.classList.toggle("bg-white", !active);
      chip.classList.toggle("border-neutral-300", !active);
      chip.classList.toggle("text-neutral-600", !active);
    });
  }
}
